import { Link } from 'react-router-dom';
import { rankingComics } from '@/mocks/comics';

export default function RankingSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门排行榜
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            根据阅读量实时排名，发现最受欢迎的韩漫作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {rankingComics.slice(0, 6).map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-primary-50/50 transition-colors duration-200 border border-background-200/70 cursor-pointer"
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                {index < 3 ? (
                  <span className={`w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full text-sm md:text-base font-bold ${
                    index === 0
                      ? 'bg-accent-500 text-background-50'
                      : index === 1
                      ? 'bg-secondary-500 text-background-50'
                      : 'bg-secondary-400 text-background-50'
                  }`}>
                    {index + 1}
                  </span>
                ) : (
                  <span className="text-lg md:text-xl font-bold text-foreground-400">
                    {index + 1}
                  </span>
                )}
              </div>

              <div className="w-14 h-20 md:w-16 md:h-24 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 truncate">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{comic.author}</p>
                <div className="flex items-center gap-3 mt-2 flex-wrap">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {comic.category}
                  </span>
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-xs text-accent-500"></i>
                    <span className="text-xs text-foreground-600">{comic.rating}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <i className="ri-eye-line text-xs text-foreground-400"></i>
                    <span className="text-xs text-foreground-400">
                      {comic.views > 10000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}